//----------------------------------------------------
// src/index.js — startpunt React-app Logboek24
//----------------------------------------------------
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { initAppSignalClient } from "./services/appSignalClient";

initAppSignalClient();

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
